<template>
	<v-row>
		<v-col>

			<v-form v-if="this.partner" v-model="formIsValid.place" ref="placeForm">
				<ui-box :form="$refs.placeForm" new-forms>

					<form-title title="Place"></form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<venue-select
								v-model="admission.venue_id"
								:rules="rules.place"
								:venues="venues"
							></venue-select>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.details" ref="detailsForm">

				<ui-box :form="$refs.detailsForm" :eager="!!product.id" new-forms>

					<form-title title="Admission Details">
						Let your customers know what's included with their admission ticket as well as
						any restrictions.
					</form-title>

					<form-divider inner/>

					<!-- Admission name -->
					<v-row>
						<v-col>
							<v-text-field
									v-model="admission.name"
									class="rounded-lg required"
									hint="Ex: General Admission, Park Admission, etc."
									label="Admission Name"
									outlined
									persistent-hint
									:rules="rules.name"
							></v-text-field>
						</v-col>
					</v-row>
					<!-- End: Admission name -->

					<!-- Included -->
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.short_information"
									:counter="1250"
									hide-details="auto"
									label="What's Included?"
									outlined
									rows="4"
							></wysiwyg-input>
						</v-col>
					</v-row>
					<!-- End: Included -->

					<!-- Restrictions -->
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="admission.restrictions"
									:counter="1250"
									hide-details="auto"
									hint="If there are no restrictions on use for this offer, leave blank."
									label="Are there restrictions?"
									outlined
									persistent-hint
									rows="4"
							></wysiwyg-input>
						</v-col>
					</v-row>
					<!-- End: Restrictions -->

				</ui-box>

			</v-form>


			<v-form v-model="formIsValid.blackoutDates" ref="blackoutDatesForm" class="mb-8">
				<blackout-dates
						:refs="$refs"
						:product="product"
						:coupon="coupon"
						:form-is-valid="formIsValid"
						:timezone="partner?.timezone || timezone"
				/>
			</v-form>

			<template  v-if="isIndividualTemplate" >
				<form-divider/>

				<v-form v-model="formIsValid.image" ref="imageForm">

					<ui-box :form="$refs.imageForm" :eager="!!product.id" new-forms v-if="!!product.id || true">

						<form-title title="Product Hero Image"></form-title>

						<form-divider inner/>

						<v-row>
							<bw-image
								v-model="editingHero"
								class="rounded-lg"
								:cols="{lg: 6, md: 8, sm: 10}"
								:upload-assignment="'product'"
								:upload-assignment-id="admission.id"
							></bw-image>
						</v-row>

					</ui-box>
				</v-form>

				<form-divider/>

				<v-form v-model="formIsValid.highlights" ref="highlightsForm" class="mb-8">

					<ui-box :form="$refs.highlightsForm" :eager="!!product.id" new-forms>

						<form-title title="Highlights">
						
						</form-title>

						<form-divider inner/>

						<v-row>
							<v-col>
								<wysiwyg-input
									v-model="admission.highlights"
									:counter="250"
									hide-details="auto"
									label="Highlights"
									outlined
									persistent-hint
									rows="4"
								/>
							</v-col>
						</v-row>

						<form-divider inner/>

						<form-title title="Learn More Description">
							Show on learn more page on checkout.
						</form-title>


						<v-row>
							<v-col>
								<wysiwyg-input
										v-model="admission.short_description"
										:counter="250"
										hide-details="auto"
										label="Learn More Description"
										outlined
										persistent-hint
										rows="4"
								></wysiwyg-input>
							</v-col>
						</v-row>

						<form-divider inner/>

						<form-title title="Allow Gifting">
							Allow gifting this product at checkout.
						</form-title>

						<v-row>
							<v-col>
								<v-switch
									v-model="admission.giftable"
									inset
									:items="[
												{ value: 1, text: 'Yes' },
												{ value: 0, text: 'No' }
										]"
									label="Allow Gifting"
								></v-switch>
							</v-col>
						</v-row>

						<form-divider inner/>

						<form-title title="Allow Transfer">
							This removes the product from the purchaser's mobile pass, and adds it to the recipient's mobile
							pass.
						</form-title>

						<v-row>
							<v-col>
								<v-switch
									v-model="admission.transferable"
									inset
									:items="[
												{ value: 1, text: 'Yes' },
												{ value: 0, text: 'No' }
										]"
									label="Allow Transfer"
								></v-switch>
							</v-col>
						</v-row>
					</ui-box>
				</v-form>
			</template>

			<form-divider/>

			<v-form v-model="formIsValid.retail" ref="retailForm">

				<v-form v-model="formIsValid.retail" ref="retailForm" class="mb-8">
					<pricing-form :refs="$refs" :admission="admission" :form-is-valid="formIsValid"
								  :origin="origin" :partner="partner" :product="product" :rules="rules"/>
				</v-form>

			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.redeemForm" ref="redeemForm" class="mb-8">
				<redeem-form :refs="$refs" :coupon="admission" :form-is-valid="formIsValid" 
							 :origin="origin" :product="product" :rules="rules"/>
			</v-form>

			<form-divider v-if="origin=='merchant-portal'"/>

			<v-form v-if="origin=='merchant-portal'" v-model="formIsValid.availability"
							ref="availabilityForm" class="mb-8">

				<ui-box :form="$refs.availabilityForm" :eager="!!product.id" new-forms>

					<form-title title="Product Availability"></form-title>

					<form-divider inner/>

					<v-row>
						<v-col cols="12">

							<!-- Added automatically -->
							<v-switch
									v-model="customFields.bw_add_to_future_passes.value"
									class="mb-4"
									dense
									false-value="No"
									hide-details="auto"
									inset
									label="Yes, include this product in future passes automatically."
									true-value="Yes"
							></v-switch>
							<!-- End: Added automatically -->

						</v-col>
					</v-row>



				</ui-box>
			</v-form>


			<mobile-pass-preview-modal
					v-if="preview.url"
					:preview-url="preview.url"
					@accept-preview="acceptPreview"
					@reject-preview="rejectPreview"
			></mobile-pass-preview-modal>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					new-forms
					save-text="Save & Preview"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
			></save-form>
		</v-col>
	</v-row>
</template>

<script>
import {admissionHelpers, productHelpers} from '../helpers';
import {templateHelpers} from '../../../../templateHelpers';
import FormDivider from "../../../../UI/Form/FormDivider.vue";
import VenueSelect from '../Shared/VenueSelect.vue';
import BlackoutDates from "@app/Shared/Components/BlackoutDates.vue";
import ButtonLanguage from "../Shared/ButtonLanguage.vue";
import WysiwygInput from "../../../../Forms/WysiwygInput/index.vue";

export default {
	name: "AdmissionProductForm",
	components: {WysiwygInput, ButtonLanguage, BlackoutDates, FormDivider, VenueSelect },
	props: {
		// The incoming product from an edit
		product: {
			type: Object,
			default: () => ({})
		},
		template: {
			type: Object,
			default: () => ({})
		},
		venue: {
			type: Object,
			default: () => ({})
		},
		venues: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		},
		origin: {
			type: String,
			default: ''
		},
		timezone: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			admission: {
				...productHelpers.productFormat(this.product),
			},

			customFields: {
				...productHelpers.customFields(this.origin, 'Yes')
			},
			formIsValid: {
				details: false,
				image: false,
				highlights:false,
				retail: false,
				availability: false
			},
			isSaving: false,
			preview: {
				product: {},
				url: undefined
			},
			rules: {},
		}
	},
	mounted() {
		this.rules = admissionHelpers.getValidationRules(this.$data);
		templateHelpers.loadCustomFields(this.admission, this.customFields);
	},
	computed: {
		editingHero: {
			get() {
				if (!this.admission) return;
				let m = this.admission.media.find(x => x.location === 'Hero');
				if (!m) {
					return {
						location: 'Hero',
						name: 'Hero',
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					};
				}
				return {
					...m,
					minDimensions: false,
					cropperSettings: m.cropperSettings || {
						limitAR: '2:1',
						x: 0,
						y: 0
					}
				};
			},
			set(v) {
				if (!this.admission) return;
				const index = this.admission.media.findIndex(x => x.location === 'Hero');
				if (index !== -1) {
					this.$set(this.admission.media, index, {
						...this.admission.media[index],
						...v,
						minDimensions: false,
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					});
				} else {
					this.admission.media.push({
						...v,
						location: 'Hero',
						minDimensions: false,
						cropperSettings: {
							limitAR: '2:1',
							x: 0,
							y: 0
						}
					});
				}
			}
		},
		isIndividualTemplate() {
			return this.template.code === 'bw_admission_individual_template';
		},
	},
	methods: {
		acceptPreview() {
			productHelpers.acceptPreview(this.admission, 'Admission', this.preview, this.getReturnUrl());
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return productHelpers.getReturnUrl(this.returnUrl, this.partner, this.venue);
		},

		rejectPreview() {
			this.isSaving = false;
			this.preview.url = undefined;
		},
		saveChanges() {
			this.admission.customFields = Object.values(this.customFields);
			this.admission.template_id = this.template.id;

			productHelpers.saveChanges(this.isSaving, this.partner, this.venue, this.admission, this.preview);

		},
	},
};
</script>
